<template>
  <div class="main">
    <BackButton />
    <h3 style="font-weight: bold; color: white">Container Delivery Details</h3>
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 90%; border-radius: 20px"
    >
      DELIVERY INSTRUCTIONS
    </div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>1</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="overlay[0] && $v.movecontainers.required"
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <!-- Move Loaded Containers start-->
          <div class="movecontainers box">
            <h4>
              {{ moveContainersQuestion }}
              <small
                v-if="!$v.movecontainers.required"
                style="color: red; font-size: 18px; font-weight: 800"
                >*</small
              >
            </h4>
            <h6 style="font-style: italic; font-size: 15px">
              Please note that your container cannot be moved after it's loaded,
              and can only be used for storage at your location. If you need
              moving or off-site storage services, we offer a
              <a
                href="https://westerncontainersales.com/rent-steel-storage-containers/pods-discount/"
                target="_blank"
                style="color: #00587d"
                >10% partner discount with PODS.</a
              >
            </h6>
            <label for="movecontainers">
              <input
                type="radio"
                id="movecontainers"
                value="Accepted"
                v-model="Bind_MoveContainers"
                @change="handleUserInputUpdate(0)"
              />
              I understand
            </label>
            <br />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Move Loaded Containers ends-->
    <!-- Space question -->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>2</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="overlay[1] && $v.deliveryspace.required"
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <div class="space box">
            <h4>
              {{ spaceQuestion }}
              <span
                href="#"
                class="pa3 btn"
                style="color: #00587d; padding: 0"
                @click.stop="showSpace = true"
              >
                <v-icon color="#6dbe45">info</v-icon>
              </span>

              <v-dialog v-model="showSpace" max-width="500px">
                <div class="dialog">
                  <v-icon
                    @click="showSpace = false"
                    style="border-radius: 0.8em; background: #6dbe45"
                    >close</v-icon
                  >
                  <h5>
                    {{ spacemessage }}
                    <span>
                      <a
                        href="https://westerncontainersales.com/buy-shipping-containers-online/delivery/"
                        target="_blank"
                        style="color: #6dbe45"
                        >Container Ground Level Delivery</a
                      >
                    </span>
                  </h5>
                </div>
              </v-dialog>
              <strong
                v-if="!$v.deliveryspace.required"
                style="color: red; font-size: 18px"
                >*</strong
              >
            </h4>
            <v-card width="400" class="mx-auto" style="margin-top: 20px">
              <v-img
                src="https://images-wcs.s3-us-west-2.amazonaws.com/Delivery_Space_20210402.png"
              ></v-img>
            </v-card>
            <br />
            <label for="space_present">
              <input
                type="radio"
                id="space_present"
                value="I confirm there is enough space"
                v-model="Bind_DeliverySpace"
                @change="handleUserInputUpdate(1)"
              />
              I confirm there is enough space to safely deliver
            </label>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Space question ends -->
    <!-- Door direction-->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>3</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="overlay[2] && $v.doordirection.required"
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <div class="doordirection box">
            <h4>
              {{ doorDirectionQuestion }}
              <span
                href="#"
                class="pa3 btn"
                style="color: #00587d; padding: 0"
                @click.stop="showDoorDirection = true"
              >
                <v-icon color="#6dbe45">info</v-icon>
              </span>
              <v-dialog v-model="showDoorDirection" max-width="500px">
                <div class="dialog">
                  <v-icon
                    @click="showDoorDirection = false"
                    style="border-radius: 0.8em; background: #6dbe45"
                    >close</v-icon
                  >
                  <h5>{{ doormessage }}</h5>
                </div>
              </v-dialog>

              <small
                v-if="!$v.doordirection.required"
                style="color: red; font-size: 18px; font-weight: 800"
                >*</small
              >
            </h4>
            <label class="grow">
              <input
                type="radio"
                id="towardscab"
                value="Doors Toward Cab (off last)"
                v-model="Bind_DoorDirection"
                @change="handleUserInputUpdate(2)"
              />
              <img
                src="https://images-generic.s3-us-west-2.amazonaws.com/PreDelivery-Door-Direction-Towards-Cab-Off-Last.png"
                width="80%"
              />
              <figcaption style="font-size: 16px">
                Doors Toward Cab (off last)
              </figcaption>
            </label>
            <label class="grow">
              <input
                type="radio"
                id="towardsrear"
                value="Doors Toward Rear (off first)"
                v-model="Bind_DoorDirection"
                @change="handleUserInputUpdate(2)"
              />
              <img
                src="https://images-generic.s3-us-west-2.amazonaws.com/PreDelivery-Door-Direction-Towards-Rear-Off-First.png"
                width="80%"
              />
              <figcaption style="font-size: 16px">
                Doors Toward Rear (off first)
              </figcaption>
            </label>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Door direction ends-->
    <!-- Surface Question Starts-->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>4</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="overlay[3] && $v.deliverysurfacetype.required"
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <div class="surface box">
            <h4>
              What Type of Surface Will We Be Delivering On?
              <small
                v-if="!$v.deliverysurfacetype.required"
                style="color: red; font-size: 18px; font-weight: 800"
                >*</small
              >
            </h4>
            <div class="iframe-container">
              <iframe
                width="600"
                height="315"
                src="https://www.youtube-nocookie.com/embed/JskBUe1jpZ4"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
              <div style="text-align: left; margin-top: 20px">
                <label for="hard_surface">
                  <input
                    type="radio"
                    id="hard_surface"
                    value="Hard surface"
                    v-model="Bind_SurfaceType"
                    @change="handleUserInputUpdate(3)"
                  />
                  <b>&nbsp;Hard</b> surfaces only (asphalt, concrete, gravel,
                  etc.)
                </label>
                <br />
                <label for="soft_surface">
                  <input
                    type="radio"
                    id="soft_surface"
                    value="Soft surface"
                    v-model="Bind_SurfaceType"
                    @change="softSurfaceConfirmation(3)"
                  />
                  The truck will drive on a
                  <b>soft</b> surface during delivery (grass, dirt, etc.)
                </label>
              </div>
            </div>
            <!-- soft surface confirmtaion start-->
            <v-dialog
              v-model="softSurfaceInfoDialog"
              persistent
              max-width="500"
            >
              <v-card style="padding: 10px">
                <div class="text-left">
                  <strong
                    >I understand that I must also provide a secondary delivery
                    location with a hard surface in case the driver is unable to
                    deliver to the preferred location on a soft surface. I am
                    responsible to notify {{ domainName }} at least one (1) full
                    business day prior to delivery if the delivery date needs to
                    be changed for any reason.</strong
                  >
                  <span style="font-weight: 100">{{ softsurfacemessage }}</span>
                </div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <div class="form-group">
                    <label for="soft_surface_acknowledgement">
                      <input
                        type="checkbox"
                        id="soft_surface_acknowledgement"
                        style="cursor: pointer"
                        @click="softSurfaceInfoDialog = false"
                        @change="handleUserInputUpdate(3)"
                        v-model="Bind_SoftSurfaceAcknowledgement"
                      />
                      Accept
                    </label>
                  </div>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- soft surface confirmtaion ends-->
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Surface Question Ends-->
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 90%; margin-top: 30px; border-radius: 20px"
    >
      TIMELINE
    </div>
    <!-- minrentalcharge question start-->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>5</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="overlay[4] && $v.twomonths.required"
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <div class="min_rental box">
            <h4>
              {{ minRentalQuestion }}
              <strong
                v-if="!$v.twomonths.required"
                style="color: red; font-size: 18px"
                >*</strong
              >
            </h4>
            <h6>
              {{ minrentalchargemessgae }}
            </h6>
            <label for="two_months">
              <input
                type="radio"
                id="two_months"
                value="Accepted"
                v-model="Bind_TwoMonths"
                @change="handleUserInputUpdate(4)"
              />
              I understand
            </label>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- minrentalcharge question end-->
    <!-- Rentals Duration start-->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>6</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="overlay[5] && $v.rentalsduration.required"
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <div class="rentalsduration box">
            <h4>
              {{ rentalsDurationQuestion }}
              <small
                v-if="!$v.rentalsduration.required"
                style="color: red; font-size: 18px; font-weight: 800"
                >*</small
              >
            </h4>
            <h6>
              {{ showrentalsdurationmessage }}
            </h6>
            <select
              class="custom-select mr-sm-2"
              id="rentalsduration"
              v-model="Bind_RentalsDuration"
              @change="handleUserInputUpdate(5)"
              style="width: 60%"
            >
              <option value="Not Sure (3 mo. min)">Not Sure (3 mo. min)</option>
              <option value="3-6 months">3-6 months</option>
              <option value="6-12 months">6-12 months</option>
              <option value="1 year or more">1 year or more</option>
            </select>
            <br />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Rentals Duration ends-->
    <!-- Unavailable for delivery question -->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <div class="unacceptable_dates box">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6">
              <h4>{{ nonAcceptableDatesQuestion }}</h4>
              <br />
              <h6>
                {{ nonAcceptableDateText }}
              </h6>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card
                color="#ffffff"
                class="question_cards"
                style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
              >
                <div class="question_number">
                  <span>7</span>
                </div>
                <div class="mx-auto" style="max-width: 350px">
                  <v-date-picker
                    v-model="Bind_NonAcceptableDates"
                    class="mt-4"
                    header-color="#00587d"
                    color="red"
                    reactive
                    multiple
                    full-width
                    :min="minDate()"
                    :allowed-dates="allowedDates"
                    @input="maintainSessionStorage()"
                  ></v-date-picker>
                  <br />
                  <v-combobox
                    v-model="Bind_NonAcceptableDates"
                    multiple
                    chips
                    success
                    small-chips
                    label="Cannot accept delivery on:"
                    prepend-icon="event"
                    readonly
                  ></v-combobox>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <!-- Unavailable for delivery question ends -->
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 90%; margin-top: 30px; border-radius: 20px"
    >
      OTHER DETAILS
    </div>
    <!-- Container Condition question -->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>8</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="overlay[7] && $v.containercondition.required"
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <div class="condition box">
            <h4>
              Please Confirm You Will Return the Container in the Condition it
              Came In
              <strong
                v-if="!$v.containercondition.required"
                style="color: red; font-size: 18px"
                >*</strong
              >
            </h4>
            <h6>{{ containerconditionmessage }}</h6>
            <label for="condition_accept">
              <input
                type="radio"
                id="condition_accept"
                value="Accepted"
                v-model="Bind_ConainerCondition"
                @change="handleUserInputUpdate(7)"
              />
              I understand
            </label>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Container Condition question ends -->
    <!-- Delivery contact details starts-->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>9</span>
          </div>
          <v-fade-transition>
            <v-overlay
              :absolute="true"
              :value="
                overlay[8] &&
                $v.deliveryname.required &&
                $v.deliveryphone.minLength &&
                $v.deliveryphone.required
              "
            >
              <i
                class="fa fa-check updateAnimation"
                style="font-size: 60px; color: green"
              ></i>
            </v-overlay>
          </v-fade-transition>
          <div class="deliverycontact box">
            <h4>
              Please Confirm Your Delivery Contact
              <strong
                v-if="
                  !(
                    $v.deliveryname.required &&
                    $v.deliveryphone.minLength &&
                    $v.deliveryphone.required
                  )
                "
                style="color: red; font-size: 18px"
                >*</strong
              >
            </h4>
            <h6>{{ deliverycontactmessage }}</h6>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="5">
                <small
                  v-if="!$v.deliveryname.required"
                  style="float: left; font-weight: 600; color: #6dbe45"
                  >Full Name Is Required</small
                >
                <br />
                <br />
                <v-text-field
                  label="Name"
                  id="DeliveryName"
                  v-model="Bind_DeliveryName"
                  solo
                  @change="handleUserInputUpdate(8)"
                >
                  <v-icon slot="prepend" color="#6dbe45">
                    mdi-account
                  </v-icon></v-text-field
                >
              </v-col>
              <v-col cols="12" sm="5">
                <small
                  v-if="!$v.deliveryphone.minLength"
                  style="
                    color: red;
                    float: left;
                    font-weight: 600;
                    color: #6dbe45;
                  "
                  >Please enter a 10-digit phone number</small
                >
                <br />
                <br />
                <v-text-field
                  label="Phone"
                  id="DeliveryPhone"
                  v-model="Bind_DeliveryPhone"
                  solo
                  @change="handleUserInputUpdate(8)"
                >
                  <v-icon slot="prepend" color="#6dbe45">
                    mdi-phone-message
                  </v-icon></v-text-field
                >
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Delivery contact details ends-->
    <!-- Delivery additional comments starts-->
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9">
        <v-card
          color="#ffffff"
          class="question_cards"
          style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
        >
          <div class="question_number">
            <span>10</span>
          </div>
          <div class="deliveryinstructions box">
            <h4>
              {{ deliveryinstructionsmessage }}
              <span>
                <br />
                <small
                  >(This could include special instructions, notes about
                  receiving hours, etc.)</small
                >
              </span>
            </h4>
            <textarea
              v-model="Bind_DeliveryInstruction"
              cols="20"
              rows="4"
              placeholder="Add instructions here..."
              class="pa1"
              @change="maintainSessionStorage()"
              style="
                border: 2px solid #c7c7c7;
                color: black;
                background-color: white;
                border-radius: 3px;
                width: 80%;
              "
            ></textarea>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Delivery additional comments ends-->

    <!--Loder starts -->
    <v-overlay :value="loader">
      <v-btn color="#6dbe45" large style="width: 130px">
        <span class="spinner-border spinner-border-sm"></span>
        Loading...
      </v-btn>
    </v-overlay>
    <!--Loder ends -->

    <v-btn
      class="btns cancel_btn"
      medium
      color="#00587d"
      style="color: #ffffff"
      @click="navigateCartPage()"
      >Cancel</v-btn
    >
    <v-btn
      @click="shopifyCheckout"
      color="#6dbe45"
      class="btns checkout_btn"
      style="color: #ffffff"
      medium
      v-if="VuexCartItem.length >= 1"
      :disabled="!checkValidations()"
      >Checkout</v-btn
    >
  </div>
</template>

<script>
import BackButton from "./BackButton";
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import * as types from "../store/types";
import { enforceFormat, formatToPhone } from "@/JS/FormatPhoneNumber";
import * as shopify_store from "@/JS/ShopifyStore";
import _ from "lodash";

export default {
  name: "Predelivery",
  components: {
    BackButton,
  },
  data() {
    return {
      showDoorDirection: false,
      doormessage:
        "It's not easy to turn a container around, so please let us know ahead of time which direction you'd like the doors to face when they roll off the truck at delivery. The customer will be charged at $125/hr for all time associated with turning the container around at the delivery location, if required. If you've ordered a container with doors on both ends, please select either option to move forward in the process.",
      showSpace: false,
      spacemessage:
        "By clicking the box below, customer verifies that they have enough space on site to safely deliver. Customer acknowledges that if driver is not able to safely deliver that they may still be charged for delivery as a " +
        "dry run" +
        "fee. Customer acknowledges they have reviewed the delivery information on our website:",
      containerconditionmessage:
        "By clicking the box below, customer verifies that they understand that the rental container will be returned in the same condition it was received. Customer will be charged for issues such as graffiti, sweep out fees, door repairs, etc., if the container is returned in a condition in which it cannot be immediately re-rented to the next customer.",
      minrentalchargemessgae:
        "By clicking the box below, the customer verifies that they accept the three (3) month minimum rental charge. Any container called off rent within the first month is subject to two months of additional rental charges. Beyond the three (3) month minimum, there are no contracts and the rental is month-to-month.",
      deliveryinstructionsmessage:
        "If Applicable, Please Add Any Additional Information About Your Delivery Here",
      deliverycontactmessage:
        "Please ensure the driver will have accurate contact information to avoid any delays or missed delivery attempts. Please note that the customer may be charged a dry run fee if we're unable to safely deliver on the scheduled delivery date.",
      multiauthtoken: "",
      showrentalsdurationmessage:
        "There are no contracts, this just helps us for planning purposes.",
      moveContainersQuestion:
        "We Don't Move Loaded Containers - Please confirm you understand that this container cannot be moved once it's loaded, and will only be used for storage at your location.",
      spaceQuestion: "Please Confirm You Have Enough Space For Delivery",
      minRentalQuestion: "Please Confirm the 3-Month Minimum Rental Charge",
      rentalsDurationQuestion:
        "How Long Will You Need the Container (just so we can plan on our end)?",
      doorDirectionQuestion: "Preferred Door Direction At Delivery",
      nonAcceptableDatesQuestion:
        "Are There Any Dates You CANNOT Accept Delivery?",
      nonAcceptableDateText:
        "We'll request the next available date with the hauler and then you'll receive an email within one (1) business day to confirm that delivery date (please note, we don't deliver on weekends or holidays). Deliveries average 2-5 business days and you'll receive an email once your delivery is scheduled (and the driver will call when they're en route on the day of delivery).",
      softSurfaceInfoDialog: false,
      softsurfacemessage:
        " Soft surfaces such as grass or dirt increases the likelihood of a dry run, usually due to the site being too wet for the truck to avoid getting stuck. Please make sure to contact us at least a day ahead of your delivery date if you need to push back delivery due to site conditions in order to avoid a dry run fee.",
      domainName: "",
      loader: false,
      overlay: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    /*Go to shopping page to select container if the cart is empty      
      Go to cart review to accept terms and conditions if not accepted already.*/
    if (this.VuexCartItem.length === 0) this.$router.push("/rentals");
    else if (!this.VuexTermsConditions) this.$router.push("/rentals/cart");
    //get domain name based on country code.
    this.domainName =
      this.COUNTRY_CODE === "CA"
        ? "Northern Container Sales"
        : "Western Container Sales";

    //Add Event Listener to auto format phone number
    this.phoneNumberElement = document.getElementById("DeliveryPhone");
    this.phoneNumberElement.addEventListener("keydown", enforceFormat);
    this.phoneNumberElement.addEventListener("keyup", formatToPhone);
  },
  beforeDestroy() {
    //Remove Event Listener which was added on phone number
    this.phoneNumberElement.removeEventListener("keydown", enforceFormat);
    this.phoneNumberElement.removeEventListener("keyup", formatToPhone);
  },
  computed: {
    ...mapGetters({
      doordirection: types.DOORDIRECTION,
      deliveryspace: types.DELIVERYSPACE,
      containercondition: types.CONTAINERCONDITION,
      twomonths: types.TWOMONTHS,
      deliveryinstructions: types.DELIVERYINSTRUCTIONS,
      deliveryname: types.DELIVERYCONTACTNAME,
      deliveryphone: types.DELIVERYCONTACTPHONE,
      nonacceptabledates: types.UNACCEPTABLEDATES,
      VuexCartItem: types.CARTLINEITEM,
      PreDeliveryAnswers: types.PREDELIVERYANSWERS,
      movecontainers: types.MOVECONTAINERS,
      rentalsduration: types.RENTALSDURATION,
      deliverysurfacetype: types.DELIVERYSURFACETYPE,
      softSurfaceAcknowledge: types.SOFTSURFACEACKNOWLEDGE,
      VuexTermsConditions: types.TERMSNCONDITIONS,
      COUNTRY_CODE: types.COUNTRY_CODE,
    }),
    //Bind all the vue variables
    Bind_DoorDirection: {
      get() {
        return this.doordirection;
      },
      set(value) {
        this.setdoordirection(value);
      },
    },
    Bind_DeliverySpace: {
      get() {
        return this.deliveryspace;
      },
      set(value) {
        this.setdeliveryspace(value);
      },
    },
    Bind_ConainerCondition: {
      get() {
        return this.containercondition;
      },
      set(value) {
        this.setcontainercondition(value);
      },
    },
    Bind_TwoMonths: {
      get() {
        return this.twomonths;
      },
      set(value) {
        this.settwomonths(value);
      },
    },
    Bind_DeliveryInstruction: {
      get() {
        return this.deliveryinstructions;
      },
      set(value) {
        this.setdeliveryinstructions(value);
      },
    },
    Bind_DeliveryName: {
      get() {
        return this.deliveryname;
      },
      set(value) {
        this.setdeliveryname(value);
      },
    },
    Bind_DeliveryPhone: {
      get() {
        return this.deliveryphone;
      },
      set(value) {
        this.setdeliveryphone(value);
      },
    },
    Bind_NonAcceptableDates: {
      get() {
        return this.nonacceptabledates;
      },
      set(value) {
        this.setnonacceptabledates(value);
      },
    },
    Bind_MoveContainers: {
      get() {
        return this.movecontainers;
      },
      set(value) {
        this.setmovecontainers(value);
      },
    },
    Bind_RentalsDuration: {
      get() {
        return this.rentalsduration;
      },
      set(value) {
        this.setrentalsduration(value);
      },
    },
    Bind_SurfaceType: {
      get() {
        return this.deliverysurfacetype;
      },
      set(value) {
        this.setDeliverySurfaceType(value);
      },
    },
    Bind_SoftSurfaceAcknowledgement: {
      get() {
        return this.softSurfaceAcknowledge;
      },
      set(value) {
        this.setSoftSurfaceAcknowledgment(value);
      },
    },
  },
  //Wrap validations like mandatory, minimum length, etc. to vuex variables storing the answers provided by the users.
  validations: {
    deliveryphone: {
      required,
      minLength: minLength(14),
    },
    deliveryname: {
      required,
    },
    doordirection: {
      required,
    },
    deliveryspace: {
      required,
    },
    containercondition: {
      required,
    },
    twomonths: {
      required,
    },
    movecontainers: {
      required,
    },
    rentalsduration: {
      required,
    },
    deliverysurfacetype: {
      required,
    },
  },
  methods: {
    ...mapActions({
      setdoordirection: types.ACTIONS_UPDATE_DOORDIRECTION,
      setdeliveryspace: types.ACTIONS_UPDATE_DELIVERYSPACE,
      setcontainercondition: types.ACTIONS_UPDATE_CONTAINERCONDITION,
      settwomonths: types.ACTIONS_UPDATE_TWOMONTHS,
      setdeliveryinstructions: types.ACTIONS_UPDATE_DELIVERYINSTRUCTIONS,
      setdeliveryname: types.ACTIONS_UPDATE_DELIVERYCONTACTNAME,
      setdeliveryphone: types.ACTIONS_UPDATE_DELIVERYCONTACTPHONE,
      setnonacceptabledates: types.ACTIONS_UPDATE_UNACCEPTABLEDATES,
      setpredeliveryanswers: types.ACTIONS_UPDATE_PREDELIVERYANSWERS,
      setmovecontainers: types.ACTIONS_UPDATE_MOVECONTAINERS,
      setrentalsduration: types.ACTIONS_UPDATE_RENTALSDURATION,
      setDeliverySurfaceType: types.ACTIONS_UPDATE_DELIVERYSURFACETYPE,
      setSoftSurfaceAcknowledgment: types.ACTIONS_UPDATE_SOFTSURFACEACKNOWLEDGE,
    }),
    checkValidations() {
      return (
        this.$v.deliveryphone.required &&
        this.$v.deliveryname.required &&
        this.$v.doordirection.required &&
        this.$v.deliveryspace.required &&
        this.$v.containercondition.required &&
        this.$v.twomonths.required &&
        this.$v.movecontainers.required &&
        this.$v.rentalsduration.required &&
        this.$v.deliverysurfacetype.required
      );
    },
    handleUserInputUpdate(idx) {
      //Check animation will appear for 1 second
      this.$set(this.overlay, idx, true);
      setTimeout(() => {
        this.$set(this.overlay, idx, false);
      }, 800);
      this.maintainSessionStorage();
    },
    softSurfaceConfirmation(idx) {
      //Open confirmtaion dialog only if user has not accepted the condition.
      if (!this.softSurfaceAcknowledge) {
        this.softSurfaceInfoDialog = true;
        return;
      }
      this.handleUserInputUpdate(idx);
    },
    maintainSessionStorage() {
      //Maintain session storage with predelivery answers
      const PreDeliveryAnswers = JSON.stringify(this.PreDeliveryAnswers);
      sessionStorage.setItem("PreDeliveryAnswers", PreDeliveryAnswers);
    },
    allowedDates(val) {
      //Disable weekends
      var day = new Date(val);
      var dayOfWeek = day.getDay();
      return dayOfWeek in [1, 2, 3, 4, 5];
    },
    minDate() {
      //Minimum data to be selected is always next day. All the past dates are disbaled.
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().slice(0, 10);
    },
    navigateCartPage() {
      this.$router.push("/rentals/cart");
    },
    getPredlivery() {
      const predeliveryData = [
        {
          question_name: "DOOR_DIRECTION",
          answer: this.doordirection,
        },
        {
          question_name: "CONTAINER_CONDITION_ACKNOWLEDGE",
          answer: this.containercondition,
        },
        {
          question_name: "DELIVERY_SPACE_ACKNOWLEDGE",
          answer: this.deliveryspace,
        },
        {
          question_name: "TWO_MONTHS_RENT_ACKNOWLEDGE",
          answer: this.twomonths,
        },
        {
          question_name: "NON_ACCEPTABLE_DATES",
          answer: this.nonacceptabledates,
        },
        {
          question_name: "ADDITIONAL_COMMENTS",
          answer: this.deliveryinstructions,
        },
        {
          question_name: "ORDER_CONTACT_NAME",
          answer: this.deliveryname,
        },
        {
          question_name: "ORDER_CONTACT_PHONENUMBER",
          answer: this.deliveryphone,
        },
        {
          question_name: "RENTALS_DURATION",
          answer: this.rentalsduration,
        },
        {
          question_name: "MOVE_CONTAINERS_ACKNOWLEDGE",
          answer: this.movecontainers,
        },
        {
          question_name: "DELIVERY_SURFACE",
          answer: this.deliverysurfacetype,
        },
      ];

      return [
        {
          key: "PreDeliverySurvey",
          value: JSON.stringify(predeliveryData),
        },
        {
          key: "market_code",
          value: this.VuexCartItem[0].market_code,
        },
      ];
    },
    getLineItems() {
      let lines = [];
      this.VuexCartItem.forEach((element) => {
        lines.push({
          quantity: element.quantity,
          merchandiseId: element.variantId,
          sellingPlanId: element.sellingPlanId,
          attributes: [
            {
              key: "Delivery",
              value: "RENTAL",
            },
          ],
        });
      });
      return lines;
    },
    shopifyCheckout: _.throttle(function () {
      this.loader = true;
      let url, tokenID;
      if (this.COUNTRY_CODE === "US") {
        url = shopify_store.USAShopifyStorefrontUrl;
        tokenID = shopify_store.USAStorefrontAccessToken;
      } else if (this.COUNTRY_CODE === "CA") {
        url = shopify_store.CanadaShopifyStorefrontUrl;
        tokenID = shopify_store.CanadaStorefrontAccessToken;
      }

      let headers_list = {
        "X-Shopify-Storefront-Access-Token": tokenID,
        "content-type": "application/json",
      };

      const query = `
        mutation cartCreateMutation($cartInput: CartInput) {
          cartCreate(input: $cartInput) {
            cart {
              id
              checkoutUrl
            }
          }
        }
      `;
      const variables = {
        cartInput: {
          lines: this.getLineItems(),
          attributes: this.getPredlivery(),
        },
      };

      axios({
        url: url,
        method: "post",
        data: {
          query: query,
          variables: variables,
        },
        headers: headers_list,
      })
        .then((res) => {          
          let webUrl = res.data.data.cartCreate.cart.checkoutUrl;
          window.location.href = webUrl;          
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          this.loader = false;
        });
    }, 4000),
  },
};
</script>

<style scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css);

.main {
  border-radius: 15px;
  margin: auto;
  width: 80%;
  padding: 10px;
  text-align: center;
  color: black;
  margin-bottom: 60px;
  color: #ffffff;
}
.question_cards {
  padding-top: 30px;
  padding-bottom: 20px;
  margin: 20px;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
}

.btns {
  height: 50px;
  color: #00587d;
  text-decoration: none;
  text-transform: unset !important;
  border-radius: 20px;
  font-weight: 900;
  margin: 10px;
}

.checkout_btn {
  box-shadow: 1px 1px 1px 1px #ffffff;
}
.cancel_btn {
  box-shadow: 1px 1px 1px 1px #6dbe45;
}

h5,
textarea {
  font-size: 14px;
  font-weight: normal;
}

h4 {
  font-size: 18px;
  font-weight: bold;
}

h6 {
  font-style: italic;
  font-size: 15px;
  margin-bottom: 20px;
}

label {
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}

input[type="radio"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.doordirection input[type="radio"] {
  display: none;
}

.doordirection input[type="radio"]:checked + img {
  border: 5px solid #6dbe45;
}

[type="radio"] + img {
  cursor: pointer;
  border-radius: 10px;
}

.box {
  padding: 15px;
  margin-left: 20px;
}

.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

.v-card__text,
.v-card__title {
  word-break: normal;
}

@media only screen and (min-width: 760px) {
  textarea {
    width: 100%;
  }
}

@media only screen and (max-width: 1200px) {
  .main {
    max-width: 100%;
  }
}

@media only screen and (max-width: 430px) {
  .main {
    width: 100%;
  }
}

@media only screen and (max-width: 400px) {
  v-date-picker {
    max-width: 320px;
  }
}

.iframe-container {
  width: 600px;
  margin: auto;
}

@media only screen and (max-width: 800px) {
  .iframe-container {
    position: relative;
    width: 100%;
    height: 90%;
  }
  .iframe-container iframe {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 90%;
  }
}

.question_number {
  background-color: #6dbe45;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.8);
  height: 70px;
  left: -50px;
  position: absolute;
  top: -50px;
  width: 100px;
  -webkit-transform: rotate(-45deg);
}

.question_number span {
  color: #f5f5f5;
  font-family: sans-serif;
  font-size: 0.8em;
  left: 5px;
  top: 52px;
  position: absolute;
  width: 70px;
}

.updateAnimation {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  opacity: 0.6 !important;
  background-color: #ffffff !important;
}
</style>